import React from 'react';
import { Link } from 'react-router-dom';

import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Box, ButtonNew } from 'components/Wrapped';

import styles from './TopBar.module.scss';

const PublicNav = ({ t: translate, enableLogin, loginButtonTheme = 'black' }) => {
  // const t = nestedTranslate(translate, 'navbar.links');

  return (
    <React.Fragment>
      {enableLogin && (
        <Box pad="none" direction="row" gap="8px" className={styles.publicNav}>
          <Link to="/login">
            <ButtonNew label="Войти" theme={loginButtonTheme} />
          </Link>
          <Link to="/signup">
            <ButtonNew label="Регистрация" />
          </Link>
        </Box>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({
  exchangeSettings: {
    settings: { enableLogin },
  },
}) => ({
  enableLogin,
});

export default withNamespaces()(connect(mapStateToProps)(PublicNav));
